module.exports = __webpack_public_path__ + "img/58.fa898c65.png";